import { defineMessages } from 'react-intl';

export const whyConfluenceSectioni18n = defineMessages({
	whyConfluenceSectionHeader: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.Header',
		defaultMessage: 'Why Confluence?',
	},
	versatileContentCreationInfoBoxTitle: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Title',
		defaultMessage: 'Versatile content creation',
	},
	versatileContentCreationInfoBoxParagraph: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.VersatileContentCreation.Paragraph',
		defaultMessage:
			'Bring your ideas to life with a rich palette of content: Whiteboards, Databases, and videos within every Confluence Page.',
	},
	organizationThatScalesInfoBoxTitle: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Title',
		defaultMessage: 'Organization that scales',
	},
	organizationThatScalesInfoBoxParagraph: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.OrganizationThatScales.Paragraph',
		defaultMessage:
			'You’ll never outgrow Confluence. Project resources and company knowledge stay centralized and discoverable.',
	},
	powerfulIntegrationsInfoBoxTitle: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Title',
		defaultMessage: 'Powerful integrations',
	},
	powerfulIntegrationsInfoBoxParagraph: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.PowerfulIntegrations.Paragraph',
		defaultMessage:
			'Connect Confluence to thousands of your favorite tools to access data and manage workflows across apps.',
	},
	dataProtectionInfoBoxTitle: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Title',
		defaultMessage: 'Data protection',
	},
	dataProtectionInfoBoxParagraph: {
		id: 'ConfluenceSoftwarePage.v4.WhyConfluenceSection.InfoBox.DataProtection.Paragraph',
		defaultMessage:
			'User-level permissions keep your information private. Company data stays secure and always remains in your control.',
	},
});
